<template>
  <div class="securityCheck"  style="margin-top: 220px;">
    <div class="shop-carBox comWidth">
      <div class="f_seacher">
        <div class="one">
          <img src="../../assets/icon/f_seacher.jpg" alt="產品防偽查詢">
        </div>
        <div class="two">
          <h3>產品防偽查詢</h3>
          <form>
            <input type="text" v-model="code" placeholder="請輸入產品防偽碼查詢" class="on" name="code" value="">
            <input type="button" @click="getData" value="點擊查詢" class="tw">
          </form>
        </div>
        
      </div>
      
    </div>
    <div class="z_seacher_n" v-if="isShow">
        <h3>查詢結果</h3>
        <p v-if="!data.goods_name">您輸入的防偽碼不正確，請輸入正確的防偽碼</p>
        <div v-else>
        <div class="list" style="text-align:left;">
          尊貴的顧客：<br>
          <p style="text-indent: 2em;">您好！</p>
        </div>
        <div class="list" style="text-indent: 2em;">
          <span>● 您查詢的商品為:</span> 
          <p style="color: #0073b9">{{data.goods_name}}</p>
        </div>
        <div class="list" style="text-indent: 2em;">
            <span>● 該防偽碼查詢為：</span>
            <p>第{{data.count}}次查詢</p>
        </div>
        <div class="list" style="text-indent: 2em;">
          <span>● 查詢時間為：</span><p>{{data.created_at}}</p>

        </div>
        <div class="list" v-if="data.query.length > 0">
          <span>之前查詢記錄：</span>
          <table class="table table-bordered">
            <tbody><tr>
              <th style="text-align: center;">查詢時間</th>
              <th style="text-align: center;">查詢IP</th>
            </tr>
            <tr v-for="(el, index) in data.query" :key="index">
              <td>
              {{el.created_at}}
              </td>
              <td>
                {{el.ip}}
              </td>
            </tr>
                            </tbody></table>
        </div>
        <p>感謝您選擇冬蟲夏草領域最高科技成果——{{data.goods_name}}。</p>
        <p><a href="/article_help.php?id=1&amp;sub_id=18" style="color: #0072b9">【瞭解產品服用說明，敬請點擊】</a></p>
        <p style="text-align: right;padding-right: 361px;">
          澳門極草
        </p>
        </div>
      </div>
    <!--导航-->
    <NavB :titleChild="titleChild"/>
  </div>
</template>

<script>
  import { shoppingMall } from '@/api/security'
  import NavB from '@/pages/detailsPage/NavB'
  export default {
    name: 'SecurityCheck',
    components:{
      NavB
    },
    data () {
      return {
        code: undefined,
        data: [],
        isShow: false,
        titleChild:[{name:'首頁',src:'HomePage'},{name:'極草產品',src:'ProductPage'},{name:'產品防偽查詢',src:'SecurityCheck'}],
      }
    },
    created(){
      window.scrollTo(0,0)
    },
    methods: {
      getData() {
        shoppingMall({ code: this.code }).then(res => {
          this.isShow = true
          this.data = res.data
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .f_seacher{
    width: 810px;
    margin: 0 auto;
    margin-top: 55px;
    margin-bottom: 50px;
    overflow: hidden;
    display: flex;
    .one{
      width: 348px;
      img{
        width: 348px;
        height: 262px;
        display: block;
      }
    }
    .two{
      width: 400px;
      margin-top: 80px;
      h3{
        font-size: 30px;
        color: #0073b9;
        margin-bottom: 38px;
      }
      input{
        height: 38px;
        font-size: 14px;
      }
      .on{
        width: 298px;
        border: 1px solid #e6e6e6;
        background-color: #fafafa;
        text-indent: 12px;
        line-height: 36px;
        border-radius: 4px;
      }
      .tw{
        width: 80px;
        background-color: #015fa9;
        color: #fff;
        border-radius: 2px;
      }
      
    }
  }

  .z_seacher_n {
    width: 1200px;
    margin: 50px auto;
    font-size: 14px;
    color: #b2b2b2;
    line-height: 30px;
    background-color: #f9f9f9;
    padding: 30px 0;
    overflow: hidden;
    text-align: center;
    h3 {
        font-size: 28px;
        color: #373737;
        margin-bottom: 24px;
    }
    .list {
        width: 40%;
        overflow: hidden;
        margin: 0 auto;
        span {
          float: left;
        }
        p {
            float: left;
            text-align: left;
        }
    }
    .table {
        width: 100%;
        max-width: 100%;
        margin-bottom: 20px;
    }
    .table-bordered {
    border: 1px solid #ddd;
}
table {
    border-spacing: 0;
    border-collapse: collapse;
}
.table-bordered>tbody>tr>th{
  border: 1px solid #ddd;
  border-collapse: collapse;
  padding: 8px;
    line-height: 1.42857143;
    vertical-align: top;
}
.table-bordered>tbody>tr>td{
  border: 1px solid #ddd;
  padding: 8px;
    line-height: 1.42857143;
    vertical-align: top;
}
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/SecurityCheck.vue